import script from "./Blocker.vue?vue&type=script&setup=true&lang=js"
export * from "./Blocker.vue?vue&type=script&setup=true&lang=js"

import "./Blocker.vue?vue&type=style&index=0&id=2bfa2541&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bfa2541"]])

export default __exports__